import { Fragment, useEffect, useMemo } from "react";

import useAppSelector from "hooks/useAppSelector";
import useAppDispatch from "hooks/useAppDispatch";
import { setViewYear } from "features/class/classSlice";
import { getClassYears } from "features/class/classAction";

const YearButton = () => {
  const { years, yearsLoading, viewedYear } = useAppSelector(
    (state) => state.class,
  );
  const dispatch = useAppDispatch();

  // Fetch once on mount. This must not depend on the years or the loading
  // flag: an empty list (no classes yet) or an error would otherwise trigger
  // a new request every time loading ends.
  useEffect(() => {
    dispatch(getClassYears());
  }, [dispatch]);

  const yearButtons = useMemo(() => {
    return [...years]
      .sort((a, b) => b - a)
      .map((year) => (
        <button
          key={year}
          className={
            year === viewedYear
              ? "bg-primary px-2 rounded text-white border border-primary transition-colors duration-200 ease-out hover:bg-primary/90"
              : "bg-[#d8d8d8] px-2 rounded transition-colors duration-200 ease-out hover:bg-[#cfcfcf]"
          }
          onClick={() => dispatch(setViewYear({ year }))}
        >
          {`${year}年度`}
        </button>
      ));
  }, [years, viewedYear, dispatch]);

  // Keep showing known tabs while they are fetched again.
  if (yearsLoading && years.length === 0) {
    return <span className="text-gray-500">...</span>;
  }

  return <Fragment>{yearButtons}</Fragment>;
};

export default YearButton;
